import { render } from "./NotificationTabs.vue?vue&type=template&id=6bf368e5&scoped=true"
import script from "./NotificationTabs.vue?vue&type=script&lang=js"
export * from "./NotificationTabs.vue?vue&type=script&lang=js"

import "./NotificationTabs.vue?vue&type=style&index=0&id=6bf368e5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bf368e5"]])

export default __exports__